module.exports = __webpack_public_path__ + "img/gitlab_new_tags.cc2ffc37.png";